import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { Amplify } from 'aws-amplify';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Amplifyの設定読み込み
Amplify.configure(environment.amplify);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
